import NewInsuranceFromDiscovered from './NewInsuranceFromDiscovered';
export default NewInsuranceFromDiscovered;
